export default "__VITE_ASSET__ab5d63cb__"